import Button from "../../classStudentManagement/components/Button";
import React, {useEffect, useState} from "react";
import LicenseSelectClassMenu from "./LicenseSelectClassMenu";
import ActiveCheckBtnOn from "../../../assets/images/classes/activeCheckBtn.png";
import ActiveCheckBtnOff from "../../../assets/images/classes/activeCheckBtnOff.png"
import Modal from "../../../components/Modal";
import ArrowGray from "../../../assets/images/arrow-gray.png";

const ActiveLicenseModal = ({ classes, selectedClass, setSelectedClass, selectedLicense, students, teacherName, schoolName, selectedIndexList, setSelectedIndexList, selectedStudentList, setSelectedStudentList, isActiveLicenseModalOpen, setIsActiveLicenseModalOpen, handleActiveLicenseStudents }) => {
    const [isEditable, setIsEditable] = useState(false);
    const [activatableStudents, setActivatableStudents] = useState(null);
    const [selectAllCheck, setSelectAllCheck] = useState(false);
    const [isModifyCheckModalOpen, setIsModifyCheckModalOpen] = useState(false);
    const [changeClass, setChangeClass] = useState(false);
    const [modifyCheckType, setModifyCheckType] = useState("");


    useEffect(() => {
        setSelectAllCheck(false);
        if (students && students.length > 0) {
            // leftLicenseDate < 0인 학생만 필터링
            const filteredStudents = students.filter(student => student.leftLicenseDate < 0);
            setActivatableStudents(filteredStudents);
        } else {
            setActivatableStudents([]); // 학생이 없을 경우 빈 배열로 초기화
        }
    }, [students]);


    const selectIndex = (item, index) => {
        setSelectedIndexList(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index) // 선택 해제 시 index 제거
                : [...prev, index] // 선택 시 index 추가
        );

        setSelectedStudentList(prev =>
            prev.includes(item.studentId)
                ? prev.filter(id => id !== item.studentId) // 선택 해제 시 studentId 제거
                : [...prev, item.studentId] // 선택 시 studentId 추가
        );
    }

    const selectAll = () => {
        if (!selectAllCheck) {
            // 선택되지 않은 상태 (false) → 전체 선택
            setSelectedIndexList(activatableStudents.map((_, index) => index));
            setSelectedStudentList(activatableStudents.map(student => student.studentId));
        } else {
            // 선택된 상태 (true) → 전체 해제
            setSelectedIndexList([]);
            setSelectedStudentList([]);
        }

        // 상태 토글
        setSelectAllCheck(prev => !prev);
    };

    const closeBtn = () => {
        if((selectedStudentList.length + selectedLicense.activeCount) > selectedLicense.totalCount){
            setSelectedIndexList([]);
            setSelectedStudentList([]);
            setIsActiveLicenseModalOpen(false);
            setSelectAllCheck(false);
        }else if(selectedIndexList && selectedIndexList.length > 0){
            setIsModifyCheckModalOpen(true);
            setModifyCheckType("closeBtn");
        }else{
            setSelectedIndexList([]);
            setSelectedStudentList([]);
            setIsActiveLicenseModalOpen(false);
            setSelectAllCheck(false);
        }
    }

    const noSaveChangeClass = () =>{
        setSelectedIndexList([]);
        setSelectedStudentList([]);
        setIsModifyCheckModalOpen(false);
        if(modifyCheckType==="closeBtn"){
            setIsActiveLicenseModalOpen(false);
            setSelectAllCheck(false);
        }else{
            setChangeClass(true);
            setModifyCheckType( null);
        }
    }

    const saveChangeClass = () => {
        handleActiveLicenseStudents();
        setIsModifyCheckModalOpen(false);
        if(modifyCheckType==="closeBtn"){
            setIsActiveLicenseModalOpen(false);
            setSelectAllCheck(false);
        }else{
          //  setChangeClass(true);
            setModifyCheckType( null);
        }
        //setChangeClass(true);
        setModifyCheckType( null);
    }

    return (
        <>
            {isActiveLicenseModalOpen &&
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 text-[#50555F]">
                    <div
                        className={`relative flex flex-col items-stretch bg-white rounded-[20px] h-[80%] shadow-lg w-[900px] hpt-[19px] pb-[32px]`}>

                        <div className="flex flex-col mt-[19px] h-[56px] gap-3 flex-none">
                            <h2 className="text-[28px] font-[700]">이용권 적용하기</h2>
                            <div className="border-[1px] bg-[#D3D3D3] w-[860px] mx-[20px]"></div>
                        </div>
                        <div className="flex-1 overflow-y-auto overflow-x-hidden pl-[116px] mt-[56px] justify-center">
                            <div className="flex w-[720px] h-[76px] rounded-[20px] border-[3px] border-[#557CFC] shadow-custom justify-center items-center">
                                <div className="flex w-[407px] h-[76px] p-2 justify-center items-center">
                                    <div className="flex flex-col px-[50px]">
                                        <div className="text-[#5E6169] text-[20px] font-[800] text-left w-[290px]">
                                            적용 개수/총 개수
                                        </div>
                                        <div className="text-[#5E6169] text-[16px] font-[400] text-left">
                                            ({selectedLicense && selectedLicense.licensePeriod})
                                        </div>
                                    </div>
                                    <div className="flex p-2 justify-center items-center">
                                        {selectedStudentList && selectedStudentList.length === 0 ? (
                                        <div className="flex px-[30px] justify-center items-center w-[297px]">
                                            <span
                                                className="text-[#355BDF] text-[20px] font-[900]">
                                                {selectedLicense.activeCount}
                                                <span className="text-[14px]">명</span>
                                            </span>

                                            <span className="text-[#5E6169] text-[20px] font-[900]">
                                                /{selectedLicense.totalCount}
                                                <span className="text-[14px]">
                                                    명
                                                </span>

                                            </span>
                                        </div>
                                        ) : (
                                            <div className="flex px-[30px] justify-center items-center w-[297px] gap-2">
                                                <div className="w-[120px]">
                                                     <span
                                                         className="text-[#355BDF] text-[20px] font-[900]">
                                                        {selectedLicense.activeCount}
                                                         <span className="text-[14px]">명</span>
                                                    </span>

                                                    <span className="text-[#5E6169] text-[20px] font-[900]">
                                                        /{selectedLicense.totalCount}
                                                        <span className="text-[14px]">
                                                            명
                                                        </span>

                                                    </span>
                                                </div>
                                                <img
                                                    src={ArrowGray}
                                                    alt="arrow gray"/>
                                                <div className="w-[120px]">
                                                     <span
                                                         className={`${(selectedLicense.activeCount + selectedStudentList.length) > selectedLicense.totalCount ? 'text-[#FC5955]' : 'text-[#00C472]'} text-[20px] font-[900]`}>
                                                        {selectedLicense.activeCount + selectedStudentList.length}
                                                         <span className="text-[14px]">명</span>
                                                    </span>

                                                    <span className="text-[#5E6169] text-[20px] font-[900]">
                                                        /{selectedLicense.totalCount}
                                                        <span className="text-[14px]">
                                                            명
                                                        </span>

                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="flex justify-between items-center w-[720px] my-[20px] px-[27px] py-[27px] rounded-[20px] bg-[#FFFFFF] border-[1px] border-[#DADADA] gap-[22px] relative">
                                <div
                                    className={`absolute left-[-55px] top-[25px] flex flex-col gap-[16px]`}
                                >
                                    {activatableStudents && activatableStudents.length > 0 ? (

                                        <button
                                            onClick={selectAll}
                                            className={`flex items-center gap-2 px-1 py-1 ${selectAllCheck ? "bg-[#7494FF] hover:bg-blue-500 " : "bg-white hover:bg-blue-50"} border-[1px] border-[#7494FF] border-solid rounded-[10px]`}
                                        >
                                            <div
                                                className={`text-base font-semibold text-center w-[36px] ${selectAllCheck ? "text-white" : "text-[#7494FF]"}  inline leading-[18px]`}>전체선택
                                            </div>
                                        </button>
                                    ) : <></>}

                                </div>
                                <div className="flex text-[#50555F] text-[17px] font-medium my-3 gap-4 max-w-[270px]">
                                    <div>
                                        {teacherName && teacherName}
                                    </div>
                                    <div>
                                        |
                                    </div>
                                    <div>
                                        {schoolName && schoolName}
                                    </div>
                                </div>
                                <div
                                    className="w-[380px] h-[44px] rounded-full relative"
                                >
                                    <LicenseSelectClassMenu
                                        classList={classes}
                                        selectedClass={selectedClass}
                                        setSelectedClass={setSelectedClass}
                                        setIsEditable={setIsEditable}
                                        selectedIndexList={selectedIndexList}
                                        setSelectedIndexList={setSelectedIndexList}
                                        setSelectedStudentList={setSelectedStudentList}
                                        setIsModifyCheckModalOpen={setIsModifyCheckModalOpen}
                                        changeClass={changeClass}
                                        setChangeClass={setChangeClass}
                                        setModifyCheckType={setModifyCheckType}
                                        type="activeLicense"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col items-start mb-4 w-[720px]">
                                <div
                                    className="flex justify-between items-center w-[720px] rounded-[10px] bg-[#F3F7FF] border-[1px] border-[#DCE8FF]">
                                    <div
                                        className="flex w-[344px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                                        번호
                                    </div>
                                    <div
                                        className="flex w-[344px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                                        이름
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col items-start gap-4 mb-24 w-[720px]">
                                {activatableStudents && activatableStudents.length > 0 ? activatableStudents.map((item, index) => (
                                    <div
                                        key={index}
                                        className="flex w-[770px] relative cursor-pointer"
                                        onClick={() => selectIndex(item,index)}
                                    >
                                        <div
                                            className={`absolute left-[-50px] top-[9px] flex flex-col gap-[16px]`}
                                        >
                                            <img
                                                src={selectedIndexList.includes(index) ? ActiveCheckBtnOn : ActiveCheckBtnOff}
                                                alt="activeCheck Icon"/>
                                        </div>
                                        <div
                                            className="flex justify-between items-center w-[720px] rounded-[10px] bg-[#FFFFFF] border-[1px] border-[#DADADA]"
                                        >
                                            <div
                                                className="flex w-[344px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500] border-r-[1px] border-[#DADADA]"
                                            >
                                                {item.number}
                                            </div>
                                            <div
                                                className="flex w-[344px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500]  border-r-[1px] border-[#DADADA]"
                                            >
                                                {item.name}
                                            </div>
                                        </div>
                                    </div>
                                )) : (
                                    <div
                                        className="flex justify-center items-center w-[720px] h-[56px] rounded-[10px] bg-[#FFFFFF] border-[1px] border-[#DADADA] text-center"
                                    >
                                        {students && students.length > 0 
                                            ? "모든 학생에게 이용권이 적용되었습니다." 
                                            : "이용권 적용 가능한 학생이 없습니다."}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="flex flex-col h-[106px] mt-[10px] gap-8 flex-none">
                            <div className="flex justify-center text-[20px] font-[500]">
                                이용권을 적용할 클래스나 학생을 체크하여 [저장하기]를 누르면 적용이 완료됩니다.
                            </div>
                            <div className="flex justify-center items-end gap-4">
                                <Button
                                    label="닫기"
                                    className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                                    onClick={() => closeBtn()}
                                />
                                <Button label="저장하기" onClick={handleActiveLicenseStudents}/>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {/* 정보 수정 확인 모달 */}
            <Modal
                isOpen={isModifyCheckModalOpen}
                onClose={() => setIsModifyCheckModalOpen(false)}
            >
                <h2 className="text-2xl font-bold mb-4">정보 수정</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <p className="my-8 text-xl font-normal">변경된 내용이 있습니다.<br/>저장하시겠습니까?</p>
                <div className="flex justify-center gap-4">
                    <Button
                        label="아니요"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => noSaveChangeClass()}
                    />
                    <Button label="저장하기" onClick={() => saveChangeClass()}/>
                </div>
            </Modal>

        </>
    )
}

export default ActiveLicenseModal;